<!--
  - Copyright Huesik (c) 2019.
  -->

<template>
  <div class="main-banner-wrapper" v-if="bannerList.length > 0">
    <agile :dots="false" ref="bannerCarousel" :unagile="bannerList.length === 1" :autoplay="true" :autoplaySpeed="3000" :timing="'ease-in-out'">
      <div class="slide" v-for="(banner) in bannerList"
          :key="banner.target_url"
          @click="moveToDetail(banner)"
      >
        <!--<img alt="배너 이미지"/>-->
        <div :style="{'background-image': 'url(' + banner.image_url + ')'}" class="background-banner"></div>
      </div>
      <!--<div class="slide" @click="moveToDetail({-->
        <!--target_url: '/detail/2784'-->
      <!--})">-->
        <!--&lt;!&ndash;<img alt="배너 이미지"/>&ndash;&gt;-->
        <!--<div :style="{'background-image': 'url(' + ExampleImage + ')'}" class="background-banner"></div>-->
      <!--</div>-->
      <template slot="prevButton">
        <img src="../../assets/images/prev.png" />
      </template>
      <template slot="nextButton">
        <img src="../../assets/images/next.png" />
      </template>
    </agile>
    <ul v-if="bannerList.length > 1">
      <li v-for="(banner, index) in bannerList"
          :key="banner.target_url"
          :class="{on: index === $refs.bannerCarousel && $refs.bannerCarousel.getCurrentSlide()}"
          @click="$refs.carousel.goTo(index)"
      >
      </li>
    </ul>
  </div>
</template>

<script>
  import ExampleImage from '../../assets/images/banner.png'
  import {VueAgile} from 'vue-agile'
  import DynamicNavigator from '../../core/modules/DynamicNavigator'
  export default {
    name: 'MainBanner',
    components: {
      agile: VueAgile
    },
    data () {
      return {
        bannerList: [],
        ExampleImage
      }
    },
    methods: {
      async fetchBannerList () {
        try {
          const bannerList = await this.axios.get('/banners')
          this.bannerList = bannerList.data.result
        } catch (error) {
          console.error(error)
        }
      },
      moveToDetail (banner) {
        if (banner.target_url.indexOf('http') > -1 || banner.target_url.indexOf('https') > -1) {
          if (banner.target_url.indexOf('.pdf') > -1) {
            window.open(`https://docs.google.com/gview?embedded=true&url=${banner.target_url}`)
          } else {
            window.open(banner.target_url, '_blank')
          }
        } else {
          let routeData = this.$router.resolve(banner.target_url)
          DynamicNavigator.getInstance().moveToDetail(routeData.href, this.$router)
        }

      }
    },
    mounted () {
      this.fetchBannerList()
    }
  }
</script>

<style scoped lang="less">
  .main-banner-wrapper {
    position: relative;
    max-height: 20rem;

    .slide {
      position: relative;
      cursor: pointer;
      .background-banner {
        height: 20rem;
        // background-size: cover;
        background-size : contain;
        background-repeat: no-repeat;
        background-position: center center;
      }
    }

    .custom-dot {
      display: flex;
      justify-content: center;
      position: absolute;
      bottom: 1.5rem;
      width: 100%;

      li {
        width: 1rem;
        height: 1rem;
        margin: 0 0.5rem;
        background:url('../../assets/images/indi.png') no-repeat no-repeat;
        cursor: pointer;
        &.on {
          background:url('../../assets/images/indi-on.png') no-repeat no-repeat;
        }
      }
    }
  }
</style>
<style lang="less">
  .main-banner-wrapper {
    .agile__actions {

      > button {
        background: transparent;
        &.agile__nav-button--next {
          position: absolute;
          top: 50%;
          right: 0;
          padding-right: 2rem;
        }

        &.agile__nav-button--prev {
          position: absolute;
          top: 50%;
          left: 0;
          padding-left: 2rem;
        }
      }
    }
  }
</style>

<style scoped lang="less" >
  @import "../../assets/css/palette";
  /* Medium devices (landscape tablets, 768px and up) */

  @media screen and (max-width: 1366px) {
    .main-banner-wrapper {
      padding-top: 3.2rem;
    }
  }

  @media screen and (max-width: 768px) {
    .main-banner-wrapper {
      max-height: 12rem;
      padding-top: 0;
      .slide {
        .background-banner {
          height: 12rem;
        }
      }
    }
  }
</style>

